import React from "react";
import Header from "../components/Header";
import LoginSection from "../sections/authentication/LoginSection";

function LoginPage() {
  return (
    <div className={ClassName.container}>
      <Header />
      <LoginSection />
    </div>
  );
}

export default LoginPage;

const ClassName = {
  container: "flex flex-col text-black relative font-main",
};
